import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import CertificateView from '@/features/membership/components/CertificateView'

function CertificatePreviewPage() {
  const [name, setName] = useState('Jane Doe')
  const [program, setProgram] = useState('Clinical Ethics Workshop')
  const [date, setDate] = useState<string | undefined>(undefined)

  return (
    <div className="p-6 grid grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle>Certificate data</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <label className="text-sm text-muted-foreground">Name</label>
            <Input value={name} onChange={(e) => setName(e.target.value)} />
          </div>

          <div>
            <label className="text-sm text-muted-foreground">Program</label>
            <Input value={program} onChange={(e) => setProgram(e.target.value)} />
          </div>

          <div>
            <label className="text-sm text-muted-foreground">Issue date (optional)</label>
            <Input placeholder="e.g. 2025-10-23" value={date ?? ''} onChange={(e) => setDate(e.target.value || undefined)} />
          </div>

          <div className="flex gap-2">
            <Button onClick={() => setName('Jane Doe')}>Reset</Button>
            <Button variant="outline">Download PDF (placeholder)</Button>
          </div>
        </CardContent>
      </Card>

      <div className="flex items-start justify-center">
        <CertificateView recipientName={name} eventName={program} trainingDate={date} />
      </div>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/certificate-preview')({
  component: CertificatePreviewPage,
})

export default CertificatePreviewPage
